module.exports = __webpack_public_path__ + "static/media/thumb_white_overlay.7f214365.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/thumbs/thumb_white_overlay.png
// module id = 1548
// module chunks = 0